/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/FormElement.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext } from 'react';
import { FormContext, TranslationsContext } from "@proxy/_contexts";
import FormInputs from "./FormInputs";

type FormElementProps = {
  togglePreview: () => void;
};

const FormElement = ({
  togglePreview,
}: FormElementProps) => {

  const translations = useContext(TranslationsContext);

  const {
    formData,
    bulkOrder,
    formRef,
    currentStep,
    validationConfig,
    validateStep,
  } = useContext(FormContext);

  return (
    <form
      action={formData.id === "Custom" ? "/a/gc/gift-card/" : "/cart/add"}
      className="gc__form"
      method="post"
      ref={formRef}
      id="gcpPurchaseForm"
    >
      {(bulkOrder === true && window.GCPSDK.table && window.GCPSDK.table.state && window.GCPSDK.table.state.rowIndex < 0) ?
        <>Please select a cell from the table</>
      :
        <>
          <div className="gc__form_header gc__section">
            {translations[`breadcrumb_${currentStep}`]}
            {validateStep(formData, validationConfig, currentStep) && (
              <div className="gc__absolute-icon"><span className="gc__icon"><svg viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fillRule="evenodd" d="M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4L9 11.6 6.7 9.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z"></path></svg></span></div>
            )}
          </div>
          <div className="gc__form_help">
            {translations[`desc_${currentStep}`]}
          </div>
          <FormInputs
            togglePreview={togglePreview}
          />
        </>
      }
    </form>
  );
};

export default FormElement;
